/* eslint-disable */
import React, { useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import ButtonComponent from '../../../../../Components/Button/button';
import SearchDropdown from '../../../../../Components/Dropdown/dropdown';
import Breakdown from '../../../../../Components/BreakDownGraph/breakDown'
import { useSnackbar } from '../../../../../Components/Snackbar/snackBarProvider';
import {
        DEAL_CLOUD_COST_FIELD,
        DEAL_CLOUD_COST_HEADER,
        CLOUD_COST,SAVE_SUCCESS,
        DELETE_CLOUD_COST,
        OOPS_TRY_AGAIN,
        UPDATE_SUCCESS
      } from '../../../../../Constants/strings';
import { v4 as uuidv4 } from 'uuid'
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '../../../../../Assets/images/svg/dar_pencil.svg';
import deleteIcon from '../../../../../Assets/images/svg/dar_delete.svg';
import MagnifyingGlass from '../../../../../Assets/images/svg/dar_magnifying.svg';
import AddIcon from '@mui/icons-material/Add';
import { Button, OutlinedInput, InputAdornment, IconButton } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import { getCloudCostDetails } from '../../../../../Api/request/costMaster';
import {saveDealCloudCost,getDealCloudCost,deleteDealCloudCost,editDealCloudCost} from '../../../../../Api/request/dealFinancial'
import UseAxios from '../../../../../Api/http/http';
import styles from './cloudCost.module.scss'
import DataGridComponent from '../../../Dashboard/Efforts/scopeDataGrid';
import NoDataFound from '../../../../../Assets/images/svg/dar_no_new_file.svg';
import { getCurrencySymbol } from '../../../../../Pages/CostMaster/costMasterUtils';
import PropTypes from 'prop-types';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

// ActionButton component moved outside the parent component
const ActionButton = ({ row, onEditClick, onDeleteClick, hasAccess }) => {
  return (
    <>
      <div className={styles['edit-and-delete-button-main']}>
        {!row?.isEditing && (
          <button
            className="role-action-edit-icon"
            aria-label="Edit"
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
            }}
            onClick={() => onEditClick(row.id)}
          >
            <img src={EditIcon} alt="Edit" />
          </button>
        )}
        <button
          aria-label="delete"
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
          }}
          onClick={() => onDeleteClick(row.id)}
        >
          <img src={deleteIcon} alt="Delete" />
        </button>
      </div>
    </>
  );
};

ActionButton.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isEditing: PropTypes.bool,
  }).isRequired,
  onEditClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  hasAccess: PropTypes.func,
};

const CloudCost = () => {
    const query = useQuery();
    const dealId = query.get('id');
    const [rows, setRows] = useState([]);
    const [costStats, setCostStats] = useState([]);
    const [isMobileView, setIsMobileView] = useState(false);
    const [operationType, setOperationType] = useState('insert');
    const [originalRows, setOriginalRows] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [environments, setEnvironments] = useState([]);
    const [selectedEnvironment, setSelectedEnvironment] = useState(null); 
    const [totalCost, setTotalCost] = useState(0);
    const [dealName, setDealName] = useState('-');
    const { snackbarOpen } = useSnackbar();
  

    // Function to assign colors dynamically based on label
    const colors = ["#08B758", "#7BC9FF", "#848AF5", "#FFD465", "#FFE8EA"]; // 5 colors

    const fetchCloudCostDetails = async () => {
      try {
              const response = await UseAxios(getCloudCostDetails());
              const { data} =response.data.data ;
              setEnvironments(data);
      } catch (error) {
        console.error('Error fetching cloud cost details:', error.message || error);
      }
    };

    const handleSave = (id) => {
      const rowToSave = rows.find((row) => row.id === id);
      saveRow(rowToSave, operationType);
    };


    const saveRow = async (rowToSave, operationType) => {
      const id = rowToSave.id;
      const payload = {
            requiredUnits:rowToSave.requiredUnits,
            softwareCostId: null,
            hardwareCostId: null,
            staffingCostId: null,
            vendorCostId: null,
            travelCostId: null,
            cloudCostId:rowToSave.costId
      };
     
      if (operationType === 'insert') {
        try {
          await UseAxios(saveDealCloudCost(payload,dealId));
          snackbarOpen(SAVE_SUCCESS, "success");
  
        } catch (error) {
          console.error('Error saving row:', error.message || error);
        }
      }
      else if (operationType === 'update') {
       
        try {
          payload.id = id;
          payload.deal_id=dealId;
          await UseAxios(editDealCloudCost(payload,id));
          snackbarOpen(UPDATE_SUCCESS, "success");
  
        } catch (error) {
          snackbarOpen(OOPS_TRY_AGAIN, "error");
          console.error('Error updating row:', error.message || error);
        }
      }
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === rowToSave.id ? { ...row, isEditing: false } : row
        )
      );
      await fetchDealCloudCostDetails();
      setOriginalRows((prev) => {
        const rest = { ...prev };
        delete rest[rowToSave.id];
        return rest;
      });
    }

    const checkMobileView = () => {
      setIsMobileView(window.innerWidth <= 1100);
    };

    const fetchDealCloudCostDetails = async () => {
      try {
        const response = await UseAxios(getDealCloudCost(dealId));
        const CostData = response?.data?.data?.costStats;
        const totalCost = response?.data?.data?.totalCost;
        const name =response?.data?.data?.dealDetails?.dealName || "DEAL NAME";
        // Injecting colors into data
        CostData.forEach((item, index) => {
          item.color = colors[index % colors.length]; // This ensures it cycles through the colors
        });

        const rowData = response?.data?.data?.list?.map((item, index) => ({
            id: item.id,
            srNo: index + 1,
            resource: item.resource,
            unit: item.unit,
            perUnitCost:item.perUnitCost,
            cost: item.cost,
            currency: item.currency,
            requiredUnits:item.requiredUnits,
            costId:item.costId,
            isEditing: false, 
            }));
          setRows(rowData);
          setCostStats(CostData)
          setTotalCost(totalCost)
          setDealName(name)
      } catch (error) {
        console.error('Error fetching cloud cost details:', error.message || error);
      }
      
    };

    useEffect( () => {
      checkMobileView();
      fetchDealCloudCostDetails();
      fetchCloudCostDetails();
      
      window.addEventListener('resize', checkMobileView);
      return () => {
          window.removeEventListener('resize', checkMobileView);
      };
      }, []);
 

    const handleChange = (e, rowId, field) => {
        const selectedEnvId = e.target.value?.id;
        setSelectedEnvironment(selectedEnvId);
        const updatedRows = rows.map(row => {
        if (row.id === rowId) {
              const selectedEnv = environments.find(env => env.id === selectedEnvId);
              return {
                ...row,
                resource: selectedEnv?.environment || row.resource,
                perUnitCost: selectedEnv?.cost || row.perUnitCost,
                unit:selectedEnv?.unit || row.unit,
                costId:selectedEnv?.id || row.costId,
              };
            }
        return row;
        });
        setRows(updatedRows);
  };

  const newCloudRow = {
    resource: '',
  };

  const isRowUnchanged = (row) => {
    return Object.keys(newCloudRow).some((key) => row[key] === newCloudRow[key]);
  };

  
 
    // Handle changes in input field
  const handleFieldChange = (rowId, field, value) => {
      const numericValue = parseInt(value, 10);
      if (numericValue >= 1 || value === '') {  // Allow empty string to reset the field
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === rowId ? { ...row, [field]: value } : row
          )
        );
      }
   };

  // Handle increment of requiredUnits
  const handleIncrement = (rowId) => {
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === rowId
            ? { ...row, requiredUnits: (parseInt(row.requiredUnits) || 0) + 1 }
            : row
        )
      );
    };
  
 // Handle decrement of requiredUnits
  const handleDecrement = (rowId) => {
  setRows((prevRows) =>
    prevRows.map((row) =>
      row.id === rowId
        ? {
            ...row,
            requiredUnits: Math.max(1, (parseInt(row.requiredUnits) || 1) - 1), // Prevent going below 1
          }
        : row
    )
  );
  };
  const handleEdit = (id) => {
    setOperationType('update');
    setOriginalRows((prev) => ({
      ...prev,
      [id]: rows.find((row) => row.id === id),
    }));
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, isEditing: true } : row))
    );
  };

  const handleClose = (id) => {
    setRows((prevRows) => {
      const updatedRows = prevRows
        .filter((row) => {
          const isUnsavedNewRow = !originalRows[id];
          return row.id !== id || !isUnsavedNewRow;
        })
        .map((row) =>
          row.id === id && originalRows[id]
            ? { ...originalRows[id], isEditing: false }
            : row
        );
      return updatedRows.map((row, index) => ({
        ...row,
        srNo: index + 1,
      }));
  });
  
    setOriginalRows((prev) => {
      const rest = { ...prev };
      delete rest[id];
      return rest;
    });
        
  };

  const handleDelete = async (id) => {
    
   try {
    const response = await UseAxios(deleteDealCloudCost(id));
    if (response.data.status === 200) {
      snackbarOpen(DELETE_CLOUD_COST, 'success');
    }
  } catch (error) {
    console.error('Error deleting award:', error);
    snackbarOpen(OOPS_TRY_AGAIN, "error");
  }
  await fetchDealCloudCostDetails();
  };
  
  const columns = [
      {
        field: DEAL_CLOUD_COST_FIELD.SR_NO,
        headerName: DEAL_CLOUD_COST_HEADER.SR_NO,
        minWidth:100,
        flex: !isMobileView ? 0.08 : undefined,
        sortable: false,
        disableColumnMenu: true,
      
      },
      {
        field: DEAL_CLOUD_COST_FIELD.ENVIRONMENT,
        headerName: DEAL_CLOUD_COST_HEADER.ENVIRONMENT,
        minWidth: 150,
        flex: !isMobileView ? 0.15 : undefined,
        sortable: false,
        disableColumnMenu: true,
        renderCell: ({row}) =>
          row.isEditing ? (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <SearchDropdown
                searchBox={false}
                placeholder='Select'
                 options={environments.map((option) => ({
                  name: option.environment,
                  id: option.id,
                  cost:option.cost,
                  unit:option.unit
                }))}
                onChange={(e) => handleChange(e, row.id, 'resource')}
                value={row.resource}
                dropdownCss={styles['text-box-css']}
              /> 
              <div className={styles.saveCancelDiv} style={{marginTop:16}} >
                <Button
                  className={styles.saveCancelBtn}
                  variant="contained"
                  sx={{
                    backgroundColor: '#6B5CE8 !important',
                    color: 'white !important',
                    '&.Mui-disabled': {
                      opacity: 0.4,
                    },
                  }}
                  onClick={() => handleSave(row.id)}
                  disabled={isRowUnchanged(row)}
                  startIcon={<CheckIcon />}
                >
                </Button>
                <Button
                  className={styles.saveCancelBtn}
                  variant="outlined"
                  style={{
                    color: '#6B5CE8',
                    borderColor: '#6B5CE8',
                  }}
                  onClick={() => handleClose(row.id)}
                  startIcon={<ClearIcon />}
                >
                </Button>
              </div>

            </div>
          ) : (
            <label className="saved-value">{row.resource}</label>
          ),
      },
      {
        field: DEAL_CLOUD_COST_FIELD.UNIT,
        headerName: DEAL_CLOUD_COST_HEADER.UNIT,
        width: 140,
        minWidth: 135,
        flex: !isMobileView ? 0.12 : undefined,
        sortable: false,
        disableColumnMenu: true,
        renderCell: ({row}) =>
          
          <label className="saved-value"> {row.unit
            ? row.unit
            : '-'}</label>
      
      },
      {
        field: DEAL_CLOUD_COST_FIELD.REQUIRED_UNIT,
        headerName: DEAL_CLOUD_COST_HEADER.REQUIRED_UNIT,
       width:130,
        minWidth: 130,
        flex: !isMobileView ? 0.1 : undefined,
        sortable: false,
        disableColumnMenu: true,
        renderCell: ({row}) =>
          row.isEditing ? (
            <div style={{}}>
               <OutlinedInput
                  value={row.requiredUnits} 
                  onChange={(e) => handleFieldChange(row.id, 'requiredUnits', e.target.value)}
                  onBlur={(e) => handleFieldChange(row.id, 'requiredUnits', e.target.value.replace(/^0+/, ''))} 
                  type="number"
                  startAdornment={
                    <InputAdornment position="start">
                      <IconButton
                        onClick={() => handleDecrement(row.id)}
                        size="small"
                        sx={{ padding: 0 }}
                      >
                        <RemoveIcon fontSize="small" sx={{ fontSize: '14px', color: '#6B5CE8' }} />
                      </IconButton>
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleIncrement(row.id)} 
                        size="small"
                        sx={{ padding: 0 }}
                      >
                        <AddIcon fontSize="small" sx={{ fontSize: '14px', color: '#6B5CE8' }} />
                      </IconButton>
                    </InputAdornment>
                  }
                  sx={{
                    width: '90px',
                    height: '32px',
                    fontSize: '14px',
                    backgroundColor: '#ECEDF4',
                    '&:hover .MuiOutlinedInput-notchedOutline': {},
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#ccc',
                    },
                    '& input[type=number]': {
                      MozAppearance: 'textfield',
                    },
                    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                      display: 'none',
                    },
                  }}
                  inputProps={{ style: { textAlign: 'center' } }}
                />
            </div>
          ) : (
            <label className="saved-value">{row.requiredUnits}</label>
          ),
      },
      {
        field: DEAL_CLOUD_COST_FIELD.COST_AND_CURRENCY,
        headerName: DEAL_CLOUD_COST_HEADER.COST_AND_CURRENCY,
        headerClassName: styles["cloudCost-header"], // Custom class for header
        width: 100,
        minWidth:100,
        flex: !isMobileView ? 0.15 : undefined,
        sortable: false,
        disableColumnMenu: true,
        renderCell: ({row}) =>
          <div className={styles.textAlign} >
            <label className="saved-value" > 
             {row.perUnitCost
              ? `${getCurrencySymbol(row.currency)}${row.perUnitCost}`
              : '-'}
              </label>
              </div>
      },{
        field: DEAL_CLOUD_COST_FIELD.TOTAL_COST,
        headerName: DEAL_CLOUD_COST_HEADER.TOTAL_COST,
        headerClassName: styles["cloudCost-header"], // Custom class for header
        width: 140,
        minWidth:140,
        flex: !isMobileView ? 0.15 : undefined,
        sortable: false,
        disableColumnMenu: true,
        renderCell: ({row}) =>
          <div className={styles.textAlign} >
          <label className="saved-value"> 
           {row.cost
            ? `${getCurrencySymbol(row.currency)}${row.cost}`
            : '-'}
            </label>
            </div>
      }
      
      
      
    ];


    const cloudCostColumns = [
        ...columns,
        {
          headerClassName: !isMobileView
            ? ''
            : `${styles['action-column']} ${styles['tableView-action-cellWidth']}`,
          cellClassName: !isMobileView
            ? ''
            : `${styles['action-cell']} ${styles['tableView-action-cellWidth']}`,
          flex: 0.01,
          width: 100,
          minWidth:100,
          renderCell: ({row}) => (
             <div
            style={{
              marginTop:'0'
            }}
            >
        <ActionButton
          row={row} 
          onEditClick={handleEdit} 
          onDeleteClick={handleDelete} 
         // hasAccess={hasAccess}
        />
            </div>
          ),
          sortable: false,
          disableColumnMenu: true,
        },
      ];

    const handleSearch = (event) => {
      setSearchText(event.target.value.toLowerCase());
    };


  const filteredRows = searchText
  ? rows.filter((row) =>
      Object.values(row).some((value) =>
        (value ? value.toString() : '').toLowerCase().includes(searchText)
      )
    )
  : rows;


  const handleAddRow = () => {
    const newRow = {
      id: uuidv4(),
      srNo: rows.length + 1,
      resource: '',
      unit: '',
      requiredUnits:1,
      perUnitCost:'',
      cost: '',
      currency: 'INR',
      costId:'',
      isEditing: true,
    };
    const updatedRows = [newRow, ...rows].map((row, index) => ({
      ...row,
      srNo: index + 1,
    }));
    setRows(updatedRows);
    setOperationType('insert');
  };

  return (

    <div className="users-manage-outer-layer">



            <div className={styles.staffingCcostSummaryDiv1}>
        <span className={styles.summaryTitle}> Cloud Cost Summary</span>
        <span className={styles.divider}></span>
        <div className={styles.logoDiv}>
          {/* <div className={styles.imgDiv}>
            <img src={HDFCERGO} className={styles.logoImg} alt="logo" />
          </div> */}
          <div className={styles.companyInfo}>
            <span className={styles.title}>{dealName}</span>
            {/* <div className={styles.durationDiv}>
              <img src={Duration} alt="Duration" />
              <span>1500 Man Days</span>
            </div> */}
          </div>
        </div>
        
        <Breakdown 
         data={costStats} 
         title={CLOUD_COST}
         showSubText={true}
          totalCost={totalCost}
         />
      </div>

    <div className="users-manage">
     

      <div
        className={`${styles['tableView-data-grid-container']} ${styles['filteredRows-tableView']}}`}
      >
        <div className={styles['cost-title-container']}>
          <div className={styles['staffing-cost-button']}>
            <h2>{CLOUD_COST}</h2>
            
            <div className={styles['tableView-buttons']}>

            <div
        className={`${styles['tableView-search-and-buttons']} ${styles['tableView-headerSection-flex']} ${styles['filteredRows-tableView']} ${styles['tableView-margin']}`}
        
      >
        <div className={styles['tableView-headerSection-main']}>
          <div
            className={`${styles['tableView-search']} ${styles['tableView-headerSection-mainSearchInput']}`}
          >
            <div className={styles['tableView-headerSection-search']}>
              <img src={MagnifyingGlass} alt="Search" />
              <input
                id="tableView-search-input"
                type="text"
                placeholder="Search..."
                onChange={handleSearch}
                className={styles['tableView-headerSection-searchInput']}
              />
            </div>
          </div>
        </div>
      </div>

          <div className={styles['add-button-style']}>
          <ButtonComponent
            variant="contained"
            label="Add"
            onClick={handleAddRow}
            startIcon={<AddIcon />}
           // disabled={!hasAccess('create')}
          />
          </div>
          
        </div>
         
          </div>

         <DataGridComponent
          dataRows={filteredRows}
          dataColumns={cloudCostColumns}
          pageSize={10}
          isEdit={setRows}
          sortFilterColumns={[]}
          isFilteredRows={filteredRows}
          onRowSelectionChange={() => {}}
          checkboxDisabled={false}
          rowHeight={150}
          noDataImage={NoDataFound}
          noDataTitle="No Cloud Cost added yet."
          noDataSubTitle="Please add it to view here"
          hideSeparator={true}
          editStateHeight={110}
          dataGridCss={styles.dataGrid}
          getRowHeight={() => 'auto'}
        />

        </div>
      </div>
    </div>  
  </div>

  )
}

export default CloudCost